import { render, staticRenderFns } from "./Grafico.vue?vue&type=template&id=0664ccea&scoped=true&"
import script from "./Grafico.vue?vue&type=script&lang=js&"
export * from "./Grafico.vue?vue&type=script&lang=js&"
import style0 from "./Grafico.vue?vue&type=style&index=0&id=0664ccea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0664ccea",
  null
  
)

export default component.exports